const images = [
  "1456116_10202778472477095_3686522649059314072_n.jpeg",
  "1609932_10202710247091503_9038544267858743985_n.jpeg",
  "10295760_10202710217290758_6520932126214148905_n.jpeg",
  "10371507_10202710272212131_3314293823444475963_n.jpeg",
  "13390989_1127839060606671_685494330_n.jpeg",
  "13400915_1127834390607138_1911557130_n.jpeg",
  "13410816_1131466796910564_251060087_o.jpeg",
  "13414677_1127836200606957_69966317_n.jpeg",
  "13453337_1131471136910130_1906026821_o.jpeg",
  "13467800_1131470793576831_1512654713_o.jpeg",
  "DSC06135.jpeg",
  "DSC06138.jpeg",
  "DSC06169.jpeg",
  "DSC08109.jpeg",
  "DSC08112.jpeg",
  "DSC08113.jpeg",
];

export default function OfertaEducationalaPage() {
  function PhotoGrid({ images }) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {images.map((img, idx) => (
          <div
            key={img}
            className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <img
              src={`/educatie/ofertaEducationala/poze/${img}`}
              alt={`Promovarea liceului ${idx + 1}`}
              className="object-fill w-full h-full"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8 text-center">
        <a
          href="/educatie/ofertaEducationala/oferta educationala 26-27..pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 text-3xl"
        >
          Oferta Educațională
        </a>
        <br />
        <a
          href="/educatie/ofertaEducationala/pliant 24-25 a4.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 text-3xl"
        >
          Pliant oferta educațională
        </a>
        <br />
        <br />
        <a
          href="/educatie/ofertaEducationala/promovare 2021 m.mp4"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 text-2xl"
        >
          Prezentare
        </a>
        <div className="flex md:space-x-10 flex-col md:flex-row justify-center ">
          <a
            href="/educatie/ofertaEducationala/admitere 2024_Liceul Tehnologic Ulmeni_invatamant liceal_001.jpg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 text-2xl"
          >
            Oferta învățământ liceal
          </a>
          <a
            href="/educatie/ofertaEducationala/admitere 2024_Liceul Tehnologic Ulmeni_invatamant profesional_001.jpg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 text-2xl"
          >
            Oferta învățământ profesional
          </a>
        </div>
        <h2 className="text-3xl font-bold my-8">Promovarea liceului</h2>
        <PhotoGrid images={images} altPrefix="Promovarea liceului" />
      </main>
    </div>
  );
}
